import { render, staticRenderFns } from "./modal-images.vue?vue&type=template&id=22aa4f55&scoped=true"
import script from "./modal-images.vue?vue&type=script&lang=js"
export * from "./modal-images.vue?vue&type=script&lang=js"
import style0 from "./modal-images.vue?vue&type=style&index=0&id=22aa4f55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aa4f55",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseImage: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/09062026_084924/resources/assets/marketplace/components/BaseImage.vue').default})
